module.exports = __webpack_public_path__ + "img/advantage_02.a36e6735.jpg";